var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"sort-item-container",class:_vm.activeClass,on:{"click":_vm.nextState}},[_c('div',{staticClass:"sort-text"},[_vm._v(" "+_vm._s(_vm.item.text)+" ")]),_c('v-icon',{staticClass:"arrow-icon",class:[_vm.upsideDownClass]},[_vm._v(" mdi-arrow-up-bold ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }